import { gql } from '@apollo/client'
import { MUTATION_STATE } from 'api/fragments'

const PAYLOAD_TYPE = 'UpdateVoohCampaignMediaPayload'

export const UPDATE_VOOH_CAMPAIGN_MEDIA = gql`
  ${MUTATION_STATE(PAYLOAD_TYPE)}
  mutation updateVoohCampaignMedia(
    $campaignId: ID!
    $media: [VoohMediumUsage!]!
  ) {
    updateVoohCampaignMedia(
      input: {
        campaignId: $campaignId
        media: $media
      }
    ) {
      voohCampaign {
        publishable
        id
      }
      ...MutationState${PAYLOAD_TYPE}Fields
    }
  }
`
